import fetch from 'isomorphic-fetch';
import { newNotification } from "./notifications";
import {API2_URL, CDM_REQUEST, CDM_EMPLOYEES, CDM_CLEAR, CDM_FAIL} from '../store/config';
import _ from "lodash";
//import { history } from "../store/store";
import { sessionService } from 'redux-react-session';

export const cdmEmployees = (state) => (dispatch) => {
    return dispatch(sessionService.loadUser)
        .then(sess => {
            const options = {headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sess.profile.access_token}`
                },
                method: 'get'
            };

            dispatch(cdmsRequest());
            dispatch(cdmsClear());

            return fetch(`${API2_URL}/cdms/employees/${state}`, options)
                .then(result => {
                    if (result.status >= 200 && result.status < 300) {
                        return result.json();
                    } else {
                        return result.json().then(Promise.reject.bind(Promise));
                    }
                })
                .then(
                    json => dispatch(cdmsData(json)),
                    error => {
                        dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
                        return dispatch(cdmsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
                    }
                )
        });
}

export const cdmEmployeesSave = (state, values) => (dispatch) => {
    return dispatch(sessionService.loadUser)
        .then(sess => {
            const options = {headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sess.profile.access_token}`
                },
                method: 'post',
                body: JSON.stringify(values)
            };

            dispatch(cdmsRequest());
            //dispatch(cdmsClear());

            return fetch(`${API2_URL}/cdms/employees/${state}`, options)
                .then(result => {
                    if (result.status >= 200 && result.status < 300) {
                        return result.json();
                    } else {
                        return result.json().then(Promise.reject.bind(Promise));
                    }
                })
                .then(
                    json => {
                        dispatch(newNotification({title:"¡Éxito!", content:json.message ? json.message:'Perfil guardado con éxito', type: "success"}));
                        return dispatch(cdmsData(json));
                    },
                    error => {
                        dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
                        return dispatch(cdmsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
                    }
                )
        });
}

const cdmsRequest = () => {
	return {
		type: CDM_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const cdmsData = (json) => {
    let employees = [];

    if(json.data && json.data.project_goals){
        _.map(json.data.project_goals, (item) => {
            if(item.project_goal_agencies){
                _.map(item.project_goal_agencies, (goal) => {
                    if(goal.employees){
                        _.map(goal.employees, (emp) => {
                            return employees.push({
                                ...emp,
                                agency_id: goal.agency_id
                            });
                        })
                    }
                })
            }
        })
    }


	return {
		type: CDM_EMPLOYEES,
		payload: {
            ...json.data,
            roles: !_.isEmpty(json.roles) ? json.roles:[],
            employees
        },
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const cdmsClear = () => {
	return {
		type: CDM_CLEAR,
		payload: {},
		permissions: [],
		timestamp: Date.now()
	}
}

const cdmsFail = (error) => {
	return {
		type: CDM_FAIL,
		error: error,
		isFetching: false,
		timestamp: Date.now()
	}
}



// WEBPACK FOOTER //
// ./src/actions/cdms.js